module.exports = __webpack_public_path__ + "img/qkl.b09b2b71.png";